module.exports = __webpack_public_path__ + "static/media/import-dropdown-show-arrow.5dc521bc.svg";